import {UtilityCounterData} from "@/http/data/utility-counter-data";

import UtilityCounterReadingData from "@/http/data/utility-counter-reading-data";

export enum UtilityCounterStatus {
    Failed = "failed",
    Unauthenticated = "unauthenticated",
    Forbidden = "forbidden",
    Empty = "empty",
    Loading = "loading",
    Ready = "ready"
}

export default class UtilityCounterState {
    counters: UtilityCounterData[] = [];

    readings: UtilityCounterReadingData[] = [];

    countersStatus: UtilityCounterStatus =
        UtilityCounterStatus.Failed;

    readingsStatus: UtilityCounterStatus =
        UtilityCounterStatus.Failed;

    selectedBuildingId: null|string = null;

    readingsFromDate: null|string = null;

    readingsUntilDate: null|string = null;

    isInitialized = false;
}